<script>
  export let action;
</script>

<div on:click={action}>
  <slot />
</div>

<style>
  div {
    cursor: pointer;
  }

  div:hover {
    color: var(--primary-light-color);
  }
</style>
